import { EventsV3 } from "@circle-react/components/EventsV3";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { Event } from "@circle-react/types";

interface EditEventModalProps {
  defaultSection?: string;
  event?: Event;
  locationType?: string;
}

const EditEventModalComponent = ({
  event,
  defaultSection,
  locationType,
}: EditEventModalProps) => {
  const { visible: isVisible, hide } = useModal();

  return (
    <EventsV3
      isOpen={isVisible}
      onClose={hide}
      event={event}
      locationType={locationType}
      initialSection={defaultSection}
    />
  );
};

export const EditEventModal = ModalManager.create(
  ({ event, defaultSection, locationType }: EditEventModalProps) => (
    <EditEventModalComponent
      event={event}
      defaultSection={defaultSection}
      locationType={locationType}
    />
  ),
);

export const useEditEventModal = () => useModal(EditEventModal);
